export default {
  head_tite: {
    tr: 'Bitexen | İşe Alım Platformu',
    en: 'Bitexen | Recruitment Platform'
  },
  page_not_found: {
    tr: 'Aradığınız sayfa bulunamadı.',
    en: 'The page you were looking for was not found.'
  },
  header_job: {
    tr: 'Tüm İlanlar',
    en: 'All Jobs'
  },
  header_about_us: {
    tr: 'Hakkımızda',
    en: 'About Us'
  },
  header_contact: {
    tr: 'İletişim',
    en: 'Contact'
  },
  full_time: {
    tr: 'Tam Zamanlı',
    en: 'Full Time'
  },
  part_time: {
    tr: 'Yarı Zamanlı',
    en: ' Part Time'
  },
  job_apply_linkedin: {
    en: 'Apply from Linkedin',
    tr: 'Linkedinden başvur'
  },
  job_apply_kariyer: {
    en: 'Apply from Kariyer',
    tr: 'Kariyerden başvur'
  },
  job_apply: {
    en: 'Apply to the this job',
    tr: 'Bu ilana başvur'
  },
  job_empty_content: {
    tr: 'Şu an aradığınız kriterlerde ilanımız bulunmamaktadır. İleride oluşacak pozisyonlarımız için CV bırakmak ister misiniz :)',
    en: 'We currently do not have any job postings in the criteria you are looking for. Would you like to send your CV for our future positions :)'
  },
  job_empty_button: {
    en: 'Leave your CV',
    tr: 'CV Bırak'
  },
  search_all: {
    tr: 'Hepsi',
    en: 'All'
  },
  search_location: {
    tr: 'Lokasyon',
    en: 'Location'
  },
  search_job_type: {
    tr: 'İş Türü',
    en: 'Job Type'
  },
  search_find_button: {
    tr: 'İşi Ara',
    en: 'Find a Job'
  },
  footer_language: {
    tr: 'Dil',
    en: 'Language'
  },
  footer_turkish: {
    tr: 'Türkçe',
    en: 'Turkish'
  },
  footer_english: {
    tr: 'İngilizce',
    en: 'English'
  },
  footer_social_media_accounts: {
    tr: 'Sosyal Medya Hesaplarımız',
    en: 'Social Media Accounts'
  },
  footer_copyright: {
    tr: '© 2018-2021 Bitexen. Her hakkı saklıdır.',
    en: '© 2018-2021 Bitexen. All rights reserved.'
  },
  footer_legal: {
    tr: 'Legal',
    en: 'Legal'
  },
  footer_user_aggr: {
    tr: 'Kullanıcı Sözleşmesi',
    en: 'User Agreement'
  },
  footer_clarification_text: {
    tr: 'Aydınlatma Metni',
    en: 'Clarification Text'
  },
  footer_express_consent_statement: {
    tr: 'Açık Rıza Beyanı',
    en: 'Express Consent Statement'
  },
  footer_commercial_message: {
    tr: 'Ticari Elektronik İleti Onayı',
    en: 'Commercial Electronic Message Confirmation'
  },
  footer_kyc: {
    tr: 'Müşteri Tanıma Esasları',
    en: 'KYC Policy'
  },
  footer_aml: {
    tr: 'SGA-TF Önlenmesi',
    en: 'AML Policy'
  },
  footer_kvk_aggr: {
    tr: 'KVK Politikası',
    en: 'KVK Policy'
  },
  footer_cookie_policy: {
    tr: 'Çerez Politikası',
    en: 'Cookie Policy'
  },
  footer_ownership_short: {
    tr: 'Fikri Mülkiyet Hakları',
    en: 'Ownership'
  },
  footer_about: {
    tr: 'Hakkımızda',
    en: 'About'
  },
  footer_who_we_are: {
    tr: 'Biz Kimiz?',
    en: 'Who We Are?'
  },
  footer_fees: {
    tr: 'Ücretler',
    en: 'Fees'
  },
  footer_limits: {
    tr: 'Limitler ve Kurallar',
    en: 'Limits and Rules'
  },
  status_page_table_title: {
    tr: 'Sistem Durumu',
    en: 'System Status'
  },
  footer_security: {
    tr: 'Güvenlik',
    en: 'Security'
  },
  footer_sponsorships: {
    tr: 'Sponsorluklarımız',
    en: 'Sponsorships'
  },
  footer_collaborations: {
    tr: 'İş Birliklerimiz',
    en: 'Collaborations'
  },
  footer_in_press: {
    tr: 'Basında Biz',
    en: 'In Press'
  },
  footer_services: {
    tr: 'Servislerimiz',
    en: 'Services'
  },
  footer_api: {
    tr: 'API',
    en: 'API'
  },
  footer_research: {
    tr: 'Araştırma',
    en: 'Research'
  },
  footer_mobile_apps: {
    tr: 'Mobil Uygulamalar',
    en: 'Mobile Apps'
  },
  footer_android: {
    tr: 'Android',
    en: 'Android'
  },
  footer_ios: {
    tr: 'Ios',
    en: 'Ios'
  },
  footer_contact: {
    tr: 'İletişim',
    en: 'Contact'
  },
  footer_contact_us: {
    tr: 'Bize Ulaşın',
    en: 'Contact Us'
  },
  footer_support: {
    tr: 'Destek',
    en: 'Support'
  },
  footer_announcements: {
    tr: 'Duyurular',
    en: 'Announcements'
  },
  search_input_placeholder: {
    tr: 'Ara',
    en: 'Search'
  }
};
